export default "__VITE_ASSET__BLFBgrxa__"